module.exports = __webpack_public_path__ + "static/media/cam3_noite_corr.84c7b4e4.webp";